<style scoped lang="scss">
form {
    h2 {
        color: #000;
    }
    ::v-deep(.formkit-select-icon) {
        height: 50px;
        margin: 0;
        padding: 0;
    }
}
main .container .card {
    background-color: rgba(91, 91, 98, 0.08);
}
</style>

<template>
	<section>
		<div class="mb-5">
			<h1 class="page-title">{{ title }}</h1>
		</div>
		<div class="max-w-screen-xl mx-auto">
			<div class="flex flex-wrap -mx-4">
				<div class="w-full lg:w-1/4 px-3">
					<div class="mb-5">
						<div class="card w-75 shadow-xl">
							<div class="card-body items-center text-center">
								<h5 class="card-title">Image Web</h5>
								<UploadImage :image-preview-url="form.imageWeb ? form.imageWeb.url : getBaseUrl() + '/media/blank2.png'" @image-removed="onImageWebRemoved" @imageUploaded="onImageWebUpload" @error="onImageUploadError" />
							</div>
						</div>
					</div>
					<div class="mb-5">
						<div class="card w-75 shadow-xl">
							<div class="card-body items-center text-center">
								<h5 class="card-title">Image Mobile</h5>
								<UploadImage :image-preview-url="form.imageMobile ? form.imageMobile.url : getBaseUrl() + '/media/blank2.png'" @image-removed="onImageMobileRemoved" @imageUploaded="onImageMobileUpload" @error="onImageUploadError" />
							</div>
						</div>
					</div>
				</div>
				<div class="w-full lg:w-3/4 px-4">
					<div class="card w-full shadow-xl">
						<div class="card-body">
							<div class="w-full">
								<FormKit type="form" :actions="false" :model="form" @submit="onSubmit" #default="{ state: { valid } }" outer-class="w-full" incomplete-message="Veuillez remplir tous les champs correctement">
									<FormKit type="text" name="title" label="Titre *" v-model="form.title" validation="required|contains_alpha|matches:/^[^/]*$/|length:0,35" :validation-messages="{
                                        required: 'Ce champ est obligatoire.',
                                        contains_alpha: 'Ce champ doit contenir des lettres..',
                                        matches: 'Ce champ ne peut contenir de “/”.',
                                        length: 'Ce champ doit contenir au maximum 35 caractères'
                                    }" />
                                    
									<FormKit type="number" name="position" label="Position *" v-model="form.position" validation="required|min:1" :validation-messages="{
                                        required: 'Ce champ est obligatoire.',
                                        min: 'Ce champ doit être un nombre décimal superieur à 0',
                                    }" />
                                    
									

									<FormKit type="text" name="label" label="Label" v-model="form.label" :validation="validationLabel" 
                                        :validation-messages="{
                                            required: 'Ce champ est obligatoire.',
                                            contains_alpha: 'Ce champ doit contenir des lettres..',
                                            matches: 'Ce champ ne peut contenir de “/”.',
                                            length: validationLabelMessageLength
                                        }"
                                    />
                                    
									<FormKit type="text" name="description" v-model="form.description" label="Description" validation="contains_alpha|matches:/^[^/]*$/|length:0,80" 
                                        :validation-messages="{
                                            required: 'Ce champ est obligatoire.',
                                            contains_alpha: 'Ce champ doit contenir des lettres..',
                                            matches: 'Ce champ ne peut contenir de “/”.',
                                            length: 'Ce champ doit contenir au maximum 80 caractères'
                                        }" 
                                    />

                                    
                                    <FormKit 
                                        type="select" 
                                        label="Type *" 
                                        name="itemType" 
                                        v-model="form.itemType" 
                                        :options="itemTypeOptions" 
                                        validation="required" 
                                        :validation-messages="{
                                        required: 'Ce champ est obligatoire.'
                                    }" />
                                    <label class="formkit-label" 
                                        v-if="form.itemType === '1' || 
                                            form.itemType === '2' || 
                                            form.itemType === '5'">
                                        Uuid
                                    </label>
                                    <label class="formkit-label" v-if="form.itemType === '4'">Lien de redirection</label>
                                    <label class="formkit-label" v-show="form.itemType === '4'">Si lien de redirection type voyage, veuillez vous assurer de mettre un de ces formats: </label>
                                    <label class="formkit-label" v-show="form.itemType === '4'">https://app.club-employes.com/voyage?id=2209{ce_token} : pour être redirigé vers un produit spécifique où 2209 représente l'id de l'offre voyage</label>
                                    <label class="formkit-label" v-show="form.itemType === '4'">https://app.club-employes.com/voyage{ce_token} : pour être redirigé vers la page d'accueil de voyage</label>
                                    
                                    <label class="formkit-label" v-if="form.itemType === '3'">Mot(s) recherché(s)</label>
                                    <FormKit type="text" name="itemValue"  v-model="form.itemValue" />
                                    
                                    <FormKit type="hidden" name="middleMenu" v-model="form.middleMenu" label="middleMenu" />

									<div class="card-actions">
										<div v-if="loading === false">
											<FormKit type="submit" :label="submitBtnLabel"  :class="{ 'btn-primary': true, 'btn-block': true }" />
										</div>
										<FormKit type="button" label="Annuler" @click="onCancel" :class="{ 'btn-secondary': true, 'btn-block': true }" />
									</div>
                                    
								</FormKit>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { useRouter } from "vue-router";
import UploadImage from "@/components/forms/UploadImage.vue";
import {IMiddleMenuItem} from "@/models/homepage/IMiddleMenuItem";
import {fetchMiddleMenuItemByUuid} from "@/_services/homepage/middleMenuItem";
import { getItemTypeOptions } from '@/_services/homepage/itemTypeServices.ts'; 

const title = ref<string>("Editer un encart ");
const submitBtnLabel = 'éditer';
const middleMenuItem = ref<IMiddleMenuItem>({} as IMiddleMenuItem);
const route = useRoute();
const uuidRouteParam = ref<string>("");
const uuidMiddleMenu = ref<string>("");
const router = useRouter();
const loading = ref<boolean>(true);
const filledFieldCount = ref<number>(0);
const itemTypeOptions = getItemTypeOptions();
const blockType = route.params.blockType;
let validationLabel = 'contains_alpha|matches:/^[^/]*$/|length:0,15';
let validationLabelMessageLength = 'Ce champ doit contenir au maximum 15 caractères';
if (blockType === 'travel') {
    validationLabel = 'contains_alpha|matches:/^[^/]*$/|length:0,30';
    validationLabelMessageLength = 'Ce champ doit contenir au maximum 30 caractères';
}

onBeforeMount(async () => {
    loading.value = true;
    uuidRouteParam.value = route.params.uuid.length ? route.params.uuid as string : "";
    
    if (uuidRouteParam.value.length) {
        middleMenuItem.value = await fetchMiddleMenuItemByUuid(uuidRouteParam.value);
        await hydrateForm(middleMenuItem.value);


        loading.value = false;
    }

    
});

const form = ref<IMiddleMenuItem>({
    title: null,
    position: null,
    label: null,
    description: null,    
    imageWeb: null,
    imageMobile: null,   
    filter: undefined,
    redirectionLink: undefined,

    itemType: null,
    itemValue: null,
    middleMenu : null,
});

const hydrateForm = (middleMenuItem: IMiddleMenuItem) => {
    form.value = {
        title: middleMenuItem.title,
        position: middleMenuItem.position,       
        label: middleMenuItem.label,
        description: middleMenuItem.description,
        imageWeb: middleMenuItem.imageWeb,
        imageMobile: middleMenuItem.imageMobile,        
        filter: middleMenuItem.filter,
        redirectionLink: middleMenuItem.redirectionLink,
        
        itemValue: middleMenuItem.itemValue,
        itemType: middleMenuItem.itemType,
        middleMenu: middleMenuItem.middleMenu,
    }
}

const onSubmit = async (formData) => {
    try {
        if (null == form.value.imageWeb || null == form.value.imageMobile) {
            swal.warning('Les deux images sont obligatoires.');
            return false;
        }

        filledFieldCount.value = 0;
        if (formData.itemValue !== '' && formData.itemValue !== undefined) {
            filledFieldCount.value++;
        }

        if (formData.filter !== '' && formData.filter !== undefined) {
            filledFieldCount.value++;
        }

        if (formData.redirectionLink !== '' && formData.redirectionLink !== undefined) {
            filledFieldCount.value++;
        }

        if(filledFieldCount.value != 1) {
            swal.error("Uniquement un des 2 champs Uuid ou le champ URL de redirection doit être rempli");
            return false;
        }

        const payload = {
            title: formData.title,
            position: parseInt(formData.position),
            itemType: parseInt(formData.itemType),
            label: formData.label,
            description: formData.description,
            itemValue: formData.itemValue,
            middleMenu: formData.middleMenu,
            redirectionLink: formData.redirectionLink !== '' && formData.redirectionLink !== undefined ? formData.redirectionLink : null,
            imageWeb: null !== form.value.imageWeb ? `${form.value.imageWeb.uuid}` : null,
            imageMobile: null !== form.value.imageMobile ? `${form.value.imageMobile.uuid}` : null
        }
        
        swal.confirm(`Êtes-vous sûr de vouloir ${submitBtnLabel} ?`,
            "Annuler",
            submitBtnLabel
        )
            .then((results) => results.isConfirmed && update(payload))
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
}

const update = (data) => {
    if(uuidRouteParam.value.length) {
        ApiService.patch('middle_menu_items', uuidRouteParam.value, data)
            .then(() => {
                loading.value = false;
                swal.info("Editer avec succès")
                    .then((result) => {
                        
                        if (result.isConfirmed) {
                            router.go(-1);
                        }
                    });
            })
            .catch((axiosError) => {
                swal.error("Une erreur est survenue lors de la modification");
                axiosError.response.data.errors.forEach((error) => {
                    if (error.message.startsWith("Item not found for")
                        || error.message.startsWith("Could not convert database value")) {
                        swal.error("Une erreur est survenue au moment de la modification, l’uuid ajoutée n’existe pas.");
                        return false;
                    }
                });
            });
    }
}

const onCancel = () => {
    swal.confirm(
        "Êtes-vous sûr de vouloir annuler l'édition ?",
        "Oui",
        "Non"
    ).then((result) => {
        if (result.isDismissed) {
            router.go(-1);
        }
    });
}

const onImageWebUpload = (image) => {
    form.value.imageWeb = image;
}

const onImageMobileUpload = (image) => {
    form.value.imageMobile = image;
}

const onImageWebRemoved = () => {
    form.value.imageWeb = null;
}

const onImageMobileRemoved = () => {
    form.value.imageMobile = null;
}

const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}
</script>